import { Component, OnInit } from '@angular/core';
import { Router} from '@angular/router';
import {ImportHistoryService} from '../../../services/importhistory.service';
import {ToastrService} from 'ngx-toastr';
import {Page} from '../../../model/page';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-import-history-clean',
  templateUrl: './import-history-clean.component.html',
  styleUrls: ['./import-history-clean.component.scss'],
  providers: [ImportHistoryService]
})
export class ImportHistoryCleanComponent implements OnInit {

  page = new Page();
  rows: Array<object>;
  public loading = false;

  constructor(
        private router: Router,
        private importHistoryService: ImportHistoryService,
        private toastr: ToastrService,
        private title: Title
  ) {
      this.page.pageNumber = 0;
      this.page.size = 100;
      this.title.setTitle('Admin - Import History');
  }

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.loading = true;
    this.importHistoryService.getStatistics().subscribe( (items: Array<object>) => {
        this.rows = items;
        window.dispatchEvent(new Event('resize'));
        this.loading = false;
    },
    error => {
        console.log(error);
        this.loading = false;
        window.dispatchEvent(new Event('resize'));
        this.toastr.error('TimeOut occured', 'Service Error', {
            timeOut: 3000,
        });
    });
  }

  onCancel() {
    this.router.navigate(['import-history']);
  }

  onRemove(date) {
    this.loading = true;
    this.importHistoryService.removeByDate(date).subscribe( result => {
      this.loadData();
    });
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/import-history/import-history-clean/import-history-clean.component.ts